import type { ManqueOeuvre } from '@artosera/shared';
import { useTranslation } from 'react-i18next';

export function ManquesFiche({ manques }: { manques: readonly ManqueOeuvre[] }) {
  const { t } = useTranslation('regie');
  if (manques.length === 0) return null;
  return (
    <div role="status">
      <p>{t('oeuvres.completude.manques', { count: manques.length })}</p>
      <ul>
        {manques.map(({ champ, bloquant }) => (
          <li key={champ}>
            {t(`oeuvres.completude.champs.${champ}`)}
            {bloquant ? t('oeuvres.completude.obligatoire') : ''}
          </li>
        ))}
      </ul>
    </div>
  );
}
